import i18n from "@/i18n";
import message from "./message";
import router from "@/router";
import * as KEYS from "@/router/routerKeys";
import { Config } from "@/sdkMethods/config";
import { getAccountInfo, getSubscriptionList } from "@/sdkMethods/account";
import ServiceSDKModule from "@gtt/service-sdk";

const AccountStatus =
  ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.service.account
    .AccountStatus;
class LoginUtils {
  static async checkLoginStatus(serviceSDK: any) {
    if (!serviceSDK.sdkContent) {
      serviceSDK.loginStatus = false;
      return false;
    }
    const statusResp = await serviceSDK.sdkContent.getAccountService().isLoggedIn();
    serviceSDK.loginStatus = statusResp;
    if (!statusResp) {
      serviceSDK.loginStatus = false;
      serviceSDK.authRequired = true;
      message.error({ message: i18n.t("loginRequired") });
      router.push({
        name: KEYS.LOGIN,
      });
      return false;
    }
    return true;
  }

  // 根据用户订阅状态决定跳转页面
  static async handleAfterLoginPage(serviceSDK: any) {
    const accountInfoResp = await getAccountInfo(serviceSDK.sdkContent);
    if (accountInfoResp.accountStatus === AccountStatus.NotActive) {
      return;
    }
    // 获取当前是否有套餐可以绑定
    const packageInfoList = Config.getPackageInfoList(
      serviceSDK.sdkContent
    );
    if (packageInfoList.length === 0) {
      router.push({
        name: KEYS.HOME,
      });
    } else {
      // 获取最新套餐信息
      const subscriptionListResp = await getSubscriptionList(
        serviceSDK.sdkContent
      );
      if (subscriptionListResp?.length) {
        router.push({
          name: KEYS.HOME,
        });
      } else {
        router.push({
          name: KEYS.WELCOME,
        });
      }
    }
  }
}

export default LoginUtils;
